import {
  IFinancingOfferCampaign,
  IFinancingOfferFormatted,
  ISelectFinancingOfferData,
  ISynchronyOffer,
  synchronyDateFormat,
} from '~/interfaces/synchrony/synchrony-interfaces';
import dayjs from 'dayjs';
import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';
import {
  filterOfferWithHighestMinPurchase,
  filterOfferWithLowestMaxPurchase,
  //   TODO:: IN STORE Offers - LIMITED
  //   getValidSpecialCampaign,
  isScheduled,
  //   TODO:: IN STORE Offers - LIMITED
  //   isValidLimitedTimeOffer,
} from './financing-offer-calculation-utils';
import {
  EverydayFinanceOffer,
  //   TODO:: IN STORE Offers - LIMITED
  //   LimitedTimeFinancingOffer,
  //   LimitedTimeFinancingOfferViewModel_SpecialCampaignOffer,
  Maybe,
  SpecialFinancingOffer,
} from '~/gql/__generated__/types';

export function notEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function calculateFinancing(
  cartTotal: number,
  promoMonths: number,
  campaign:
    | IFinancingOfferCampaign
    //   TODO:: IN STORE Offers - LIMITED
    // | LimitedTimeFinancingOfferViewModel_SpecialCampaignOffer
    | undefined,
  monthlyOfferMessage?: Maybe<string>,
) {
  // Ensure cartTotal is a number
  cartTotal = typeof cartTotal === 'number' ? cartTotal : parseFloat(cartTotal);

  const totalAmountFinanced = parseFloat(cartTotal?.toFixed(2));

  // Calculate the monthly payment, rounded up to the nearest whole number
  let monthlyPayment = Math.ceil(totalAmountFinanced / promoMonths);

  let financingMessage = monthlyOfferMessage;

  // case for first 3 months offer if applicable
  if (campaign) {
    const adjustedAmountFinanced = totalAmountFinanced - 3;
    const adjustedMonths = promoMonths - 3;
    monthlyPayment = Math.ceil(adjustedAmountFinanced / adjustedMonths);
    if (monthlyOfferMessage) {
      financingMessage = monthlyOfferMessage.replace(
        '{financedAmount}',
        monthlyPayment.toString(),
      );
    }
  }

  return { totalAmountFinanced, financingMessage, monthlyPayment };
}

dayjs.extend(tz);
dayjs.extend(utc);
dayjs.extend(isBetween);

const getCostPerMonth = (
  interestForMonths: Maybe<number> | undefined,
  cartTotalPrice: number,
) => {
  return interestForMonths ? Math.ceil(cartTotalPrice / interestForMonths) : 0;
};

export const SelectFinancingOffer = (
  props: ISelectFinancingOfferData,
  lowCostOfferName: string | null,
  returnCustomOfferArray?: boolean,
) => {
  const {
    //   TODO:: IN STORE Offers - LIMITED
    // limitedTimeFinancingOffers,
    totalPrice = 0,
    specialFinancingOffer,
    specialFinancingEnable,
  } = props;

  //   TODO:: IN STORE Offers - LIMITED
  //   const validLimitedTimeFinancingOffers = limitedTimeFinancingOffers
  //     ?.filter(notEmpty)
  //     .filter((offer) => isValidLimitedTimeOffer(offer));
  let selectedSynchronyOffer: ISynchronyOffer | undefined;

  if (specialFinancingEnable) {
    const specialFinancingOffers = specialFinancingOffer?.filter(notEmpty);
    selectedSynchronyOffer =
      specialFinancingOffers &&
      getSpecialSynchronyOffer(
        specialFinancingOffers,
        totalPrice,
        returnCustomOfferArray,
      );
  } else {
    selectedSynchronyOffer = getOtherSynchronyOffer(
      props,
      //   TODO:: IN STORE Offers - LIMITED
      //   validLimitedTimeFinancingOffers,
      lowCostOfferName,
      returnCustomOfferArray,
    );
  }
  const { isOfferFound, campaignFound, everyDayOffersForCheckout } =
    selectedSynchronyOffer ?? {};
  let bestSynchronyOffer = selectedSynchronyOffer?.bestSynchronyOffer;
  if (!isOfferFound) {
    return undefined;
  }
  if (campaignFound) {
    bestSynchronyOffer = campaignFound;
  }
  return { bestSynchronyOffer, everyDayOffersForCheckout };
};

const getSpecialSynchronyOffer = (
  specialFinancingOffer: SpecialFinancingOffer[],
  cartTotalPrice: number,
  returnCustomOfferArray?: boolean,
): ISynchronyOffer => {
  let bestOffer: IFinancingOfferFormatted = {
    numOfMonths: 0,
    costPerMonth: 0,
    //   TODO:: IN STORE Offers - LIMITED
    // isLTO: false,
    minPurchase: 0,
    everydayFinancingOfferMessage: '',
    //   TODO:: IN STORE Offers - LIMITED
    // limitedFinancingOfferMessage: '',
    cashbackFinancingOfferMessage: '',
    monthlyOfferDetails: '',
    financingOfferDescription: '',
    disclaimer: '',
    planID: '',
    isEverydayOffer: false,
  };

  let offerFound = false;

  let campaignFound: IFinancingOfferFormatted | undefined;
  let specialOffer: IFinancingOfferFormatted | undefined;
  if (!isScheduled(bestOffer) && specialFinancingOffer?.length) {
    const bestMatchedSpecialOffers: SpecialFinancingOffer[] =
      specialFinancingOffer.filter((offer) =>
        filterOfferWithHighestMinPurchase(
          offer,
          specialFinancingOffer,
          cartTotalPrice,
        ),
      );

    // try default offer
    if (bestMatchedSpecialOffers?.length > 0) {
      const {
        minPurchase,
        noInterestFor,
        offerValidStartDate,
        offerValidEndDate,
        disclaimer,
        checkoutDisplay,
        offerName,
        financingOfferDataOnPage,
        financingOfferDescription,
        planID,
      } = bestMatchedSpecialOffers[0];

      const costPerMonth = getCostPerMonth(noInterestFor, cartTotalPrice);
      bestOffer = {
        numOfMonths: noInterestFor,
        costPerMonth: costPerMonth,
        startDate: offerValidStartDate,
        endDate: offerValidEndDate,
        //   TODO:: IN STORE Offers - LIMITED
        // isLTO: false,
        minPurchase: minPurchase,
        offerName: offerName,
        financingOfferDescription: financingOfferDescription,
        disclaimer: disclaimer,
        FinancingOfferDataOnPage: financingOfferDataOnPage,
        checkoutDisplay: checkoutDisplay,
        planID,
      };
      offerFound = true;

      if (returnCustomOfferArray) {
        specialOffer = {
          numOfMonths: noInterestFor,
          costPerMonth: costPerMonth,
          startDate: offerValidStartDate,
          endDate: offerValidEndDate,
          //   TODO:: IN STORE Offers - LIMITED
          //   isLTO: false,
          minPurchase: minPurchase,
          financingOfferDescription: financingOfferDescription,
          disclaimer: disclaimer,
          offerName: offerName,
          planID,
        };
        bestOffer = specialOffer;
      }
      // Do not use default if end date is defined and has expired
      if (offerValidEndDate) {
        const endDate = dayjs(offerValidEndDate, synchronyDateFormat);
        const now = dayjs();
        if (endDate.isValid() && now.isAfter(endDate)) {
          offerFound = false;
        }
      }
    }
  }

  return {
    isOfferFound: offerFound,
    campaignFound: campaignFound,
    bestSynchronyOffer: bestOffer,
  };
};

function extractEverydayOffersArray(
  validEverydayOffers: EverydayFinanceOffer[],
  cartTotalPrice: number,
  checkoutShowEveryDayOffers: boolean | undefined,
): IFinancingOfferFormatted[] {
  return validEverydayOffers
    .map((offer) => {
      const formattedOffer: IFinancingOfferFormatted = {
        ...offer,
        numOfMonths: offer.noInterestFor,
        costPerMonth: getCostPerMonth(offer.noInterestFor, cartTotalPrice),
        planID: offer.planID,
      };
      return formattedOffer;
    })
    .filter((formattedOffer) => {
      const currOfferMinPurchase = checkoutShowEveryDayOffers
        ? 0
        : (formattedOffer.minPurchase ?? 0);
      return cartTotalPrice >= currOfferMinPurchase;
    });
}

function getOtherSynchronyOffer(
  props: ISelectFinancingOfferData,
  //   TODO:: IN STORE Offers - LIMITED
  //   validLimitedTimeFinancingOffers: LimitedTimeFinancingOffer[] | undefined,
  lowCostOfferName: string | null,
  returnCustomOfferArray?: boolean,
): ISynchronyOffer {
  const {
    everydayFinancingOffers,
    lowCostFinancingOffers,
    totalPrice = 0,
    checkoutShowEveryDayOffers,
    cashbackFinancingEnable,
    cashBackFinancingOffer,
  } = props;
  const cartTotalPrice = totalPrice;
  let bestOffer: IFinancingOfferFormatted = {
    numOfMonths: 0,
    costPerMonth: 0,
    //   TODO:: IN STORE Offers - LIMITED
    // isLTO: false,
    minPurchase: 0,
    everydayFinancingOfferMessage: '',
    //   TODO:: IN STORE Offers - LIMITED
    // limitedFinancingOfferMessage: '',
    cashbackFinancingOfferMessage: '',
    monthlyOfferDetails: '',
    financingOfferDescription: '',
    disclaimer: '',
    planID: '',
    syfModalHeading: null,
    syfModalSubHeading: null,
    additionalContentCreditCardOffer: [],
  };

  let offerFound = false;

  let campaignFound: IFinancingOfferFormatted | undefined;
  // if cashback enabled and has length check for cashback offer
  if (cashbackFinancingEnable && cashBackFinancingOffer?.length) {
    const validCashBackOffers = cashBackFinancingOffer.filter(notEmpty);
    const bestMatchCashbackOffer =
      validCashBackOffers?.filter((offer) =>
        filterOfferWithHighestMinPurchase(
          offer,
          validCashBackOffers,
          cartTotalPrice,
        ),
      ) ?? [];
    if (bestMatchCashbackOffer.length > 0) {
      const {
        minPurchase,
        noInterestFor,
        offerValidStartDate,
        offerValidEndDate,
        disclaimer,
        financeOfferDescription,
        checkoutDisplay,
        offerName,
        financingOfferDataOnPage,
        cashBackPercentageAmount,
        cashbackBannerDetails,
        cashbackFinancingOfferMessage,
        planID,
        syfModalHeading,
        syfModalSubHeading,
        additionalContentCreditCardOffer,
      } = bestMatchCashbackOffer[0];
      // if minimum purchase criteria is met, then create best offer
      const cashBackOffer: IFinancingOfferFormatted = {
        numOfMonths: noInterestFor,
        costPerMonth: getCostPerMonth(noInterestFor, cartTotalPrice),
        startDate: offerValidStartDate,
        endDate: offerValidEndDate,
        //   TODO:: IN STORE Offers - LIMITED
        // isLTO: false,
        minPurchase: minPurchase,
        offerName: offerName,
        financingOfferDescription: financeOfferDescription,
        disclaimer: disclaimer,
        FinancingOfferDataOnPage: financingOfferDataOnPage,
        isCashBack: cashbackFinancingEnable,
        checkoutDisplay: checkoutDisplay,
        cashBackPercentageAmount: cashBackPercentageAmount,
        cashbackBannerDetails: cashbackBannerDetails,
        cashbackFinancingOfferMessage: cashbackFinancingOfferMessage,
        planID,
        syfModalHeading: syfModalHeading,
        syfModalSubHeading: syfModalSubHeading,
        additionalContentCreditCardOffer: additionalContentCreditCardOffer,
      };
      offerFound = true;
      bestOffer = cashBackOffer;

      // check if current offer expired
      if (offerFound && offerValidEndDate) {
        const endDate = dayjs(offerValidEndDate, synchronyDateFormat);
        const now = dayjs();
        if (endDate.isValid() && now.isAfter(endDate)) {
          offerFound = false;
        }
      }
    }
  }

  //   TODO:: IN STORE Offers - LIMITED
  // if no offer found then check limited time financing offers
  //   if (!offerFound || !isScheduled(bestOffer)) {
  //     const bestMatchedLimitedOffer = validLimitedTimeFinancingOffers?.filter(
  //       (offer) =>
  //         filterOfferWithHighestMinPurchase(
  //           offer,
  //           validLimitedTimeFinancingOffers,
  //           cartTotalPrice,
  //         ),
  //     );
  //     if (bestMatchedLimitedOffer?.length) {
  //       const {
  //         minPurchase,
  //         noInterestFor,
  //         offerValidStartDate,
  //         offerValidEndDate,
  //         limitedFinancingOfferMessage,
  //         monthlyOfferDetails,
  //         financingOfferDescription,
  //         disclaimer,
  //         specialCampaignOffer,
  //         checkoutDisplay,
  //         offerName,
  //         planID,
  //       } = bestMatchedLimitedOffer[0];
  //       const updatedOffer = calculateFinancing(
  //         totalPrice,
  //         noInterestFor,
  //         undefined,
  //         monthlyOfferDetails,
  //       );

  //       const currentOffer: IFinancingOfferFormatted = {
  //         numOfMonths: noInterestFor,
  //         costPerMonth: updatedOffer?.monthlyPayment,
  //         startDate: offerValidStartDate,
  //         endDate: offerValidEndDate,
  //         isLTO: true,
  //         minPurchase: minPurchase,
  //         limitedFinancingOfferMessage: limitedFinancingOfferMessage,
  //         monthlyOfferDetails: updatedOffer?.financingMessage,
  //         financingOfferDescription: financingOfferDescription,
  //         disclaimer: disclaimer,
  //         specialCampaign: specialCampaignOffer,
  //         checkoutDisplay: checkoutDisplay,
  //         offerName: offerName,
  //         planID,
  //       };
  //       bestOffer = currentOffer;
  //       offerFound = true;

  //       // check if campaign schedule is scheduled, otherwise fall back to parent offer
  //       const validCampaign = getValidSpecialCampaign(currentOffer);
  //       if (validCampaign) {
  //         currentOffer.startDate = validCampaign.campaignValidStartDate;
  //         currentOffer.endDate = validCampaign.campaignValidEndDate;
  //         campaignFound = currentOffer;
  //       } else {
  //         campaignFound = undefined;
  //       }
  //     }
  //   }
  let everyDayOffersForCheckout: IFinancingOfferFormatted[] | undefined;
  // if no offer found then check everyday financing offer
  if (!offerFound || !isScheduled(bestOffer)) {
    // try default offer
    offerFound = false;

    const validEverydayOffers = everydayFinancingOffers?.filter(notEmpty);
    const bestMatchedEverydayOffers = validEverydayOffers?.filter((offer) =>
      filterOfferWithHighestMinPurchase(
        offer,
        validEverydayOffers,
        cartTotalPrice,
      ),
    );
    if (bestMatchedEverydayOffers?.length) {
      const {
        minPurchase,
        noInterestFor,
        offerValidEndDate,
        monthlyOfferDetails,
        financingOfferDescription,
        disclaimer,
        everydayFinancingOfferMessage,
        offerName,
        planID,
        syfModalHeading,
        syfModalSubHeading,
        additionalContentCreditCardOffer,
      } = bestMatchedEverydayOffers[0];
      let currentOfferAccepted = false;

      bestOffer = {
        numOfMonths: noInterestFor,
        costPerMonth: getCostPerMonth(noInterestFor, cartTotalPrice),
        //   TODO:: IN STORE Offers - LIMITED
        // isLTO: false,
        minPurchase: minPurchase,
        everydayFinancingOfferMessage: everydayFinancingOfferMessage,
        offerName: offerName,
        monthlyOfferDetails: monthlyOfferDetails,
        financingOfferDescription: financingOfferDescription,
        disclaimer: disclaimer,
        planID,
        isEverydayOffer: true,
        syfModalHeading: syfModalHeading,
        syfModalSubHeading: syfModalSubHeading,
        additionalContentCreditCardOffer: additionalContentCreditCardOffer,
      };
      offerFound = true;
      currentOfferAccepted = true;

      if (returnCustomOfferArray && validEverydayOffers?.length) {
        everyDayOffersForCheckout = extractEverydayOffersArray(
          validEverydayOffers,
          cartTotalPrice,
          checkoutShowEveryDayOffers,
        );
      }
      // Do not use default if end date is defined and has expired
      if (currentOfferAccepted && offerValidEndDate) {
        const endDate = dayjs(offerValidEndDate, synchronyDateFormat);
        const now = dayjs();
        if (endDate.isValid() && now.isAfter(endDate)) {
          offerFound = false;
        }
      }
    }
  }
  // At last, return lowcost offer if criteria is matched
  const validLowcostOffers = lowCostFinancingOffers?.filter(notEmpty);
  const bestMatchedLowcostOffers = validLowcostOffers?.filter((offer) =>
    filterOfferWithLowestMaxPurchase(
      offer,
      validLowcostOffers,
      cartTotalPrice,
      lowCostOfferName,
    ),
  );
  if (bestMatchedLowcostOffers?.length) {
    const {
      maxPurchase,
      lowCostFinancingOfferMessage,
      defaultNumberOfMonths,
      disclaimer,
      financingOfferDescription,
      offerName,
    } = bestMatchedLowcostOffers[0];
    const LCO = {
      offerName: offerName,
      maxPurchase: maxPurchase,
      lowCostFinancingOfferMessage: lowCostFinancingOfferMessage,
      financingOfferDescription: financingOfferDescription?.replace(
        /{defaultNumOfMonths}/g,
        `${defaultNumberOfMonths?.toString() || 6}`,
      ),
      disclaimer: disclaimer,
    };
    offerFound = true;
    bestOffer = LCO;
  }
  return {
    isOfferFound: offerFound,
    campaignFound: campaignFound,
    bestSynchronyOffer: bestOffer,
    everyDayOffersForCheckout,
  };
}
